module.exports = __webpack_public_path__ + "static/media/iconEnvelope.7aa88010.svg";